class VwHbsHastaservisDTO {
  id: number = null;
  tip?: number = null;
  giristip?: number = null;
  kimlikId?: number = null;
  muracaatId?: number = null;
  servisId?: number = null;
  doktorId?: number = null;
  asistanId?: number = null;
  hemsireId?: number = null;
  yil?: number = null;
  protokolId?: number = null;
  tarih?: string = null;
  servissira?: number = null;
  doktorsira?: number = null;
  islemdurum?: number = null;
  giristarih?: string = null;
  cikistarih?: string = null;
  cikisyerId?: number = null;
  cikisaciklama?: string = "";
  yatakId?: number = null;
  iptal?: string = "H";
  iptalTarihi?: string = null;
  iptalKullanici?: number = null;
  ekleyenKullanici?: number = null;
  eklemeTarihi?: string = null;
  guncelleyenKullanici?: number = null;
  guncellemeTarihi?: string = null;
  boy?: number = null;
  kilo?: number = null;
  girisKullanici?: number = null;
  aciklama?: string = "";
  nakilServisId?: number = null;
  nakilDoktorId?: number = null;
  nakilGeldigiId?: number = null;
  kontrolhastaservisId?: number = null;
  servis?: string = "";
  doktor?: string = "";
  bagliOrganizasyonId?: number = null;
  treekey?: string = "";
  fkHbsBransId?: number = null;
  fkServistip?: number = null;
  doktorAd?: string = "";
  sevkliHasta?: string = "";
  sevkNo?: string = "";
  sevkTarihi?: string = null;
  sigortaKurumId?: number = null;
};
export default VwHbsHastaservisDTO;